{
  "All Invoices": "Todas las Facturas — {{name}}",
  "View Invoice": "Ver Factura",
  "invoices_one": "{{count}} factura",
  "invoices_other": "{{count}} facturas",
  "You currently don't have any invoices here": "Actualmente no tienes ninguna factura aquí",
  "Back": "Atrás"
}
